import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export interface IndonesiaCity {
  stateId: string;
  value: string;
}

interface GetIndonesiaCitiesParams {
  stateId: string;
  token: string;
}

interface GetIndonesiaCitiesResponse {
  data: IndonesiaCity[];
}

/**
 * Fetches cities for an Indonesian state from Wallex API
 * API endpoint: POST /trade-directory/wallex/cities
 */
const getIndonesiaCities = async ({
  stateId,
  token,
}: GetIndonesiaCitiesParams): Promise<IndonesiaCity[]> => {
  try {
    const response = await axios.post<GetIndonesiaCitiesResponse>(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/wallex-onboarding/cities`,
      { stateId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    // Handle both response structures: { data: [...] } or direct array
    const cities = response.data?.data || response.data || [];
    return Array.isArray(cities) ? cities : [];
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    throw new Error(message);
  }
};

export default getIndonesiaCities;
